export const checkAnswerDate = (date) => {
  return date === void 0 || date.getFullYear() >= 1e3 && date.getFullYear() < 2101;
};
